/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Venue_FilterInputs */

const cs_calendar_venue_filter = /** @type {(inputs: Calendar_Venue_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočka`)
};

const en_calendar_venue_filter = /** @type {(inputs: Calendar_Venue_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch`)
};

/**
* | output |
* | --- |
* | "Branch" |
*
* @param {Calendar_Venue_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_venue_filter = /** @type {((inputs?: Calendar_Venue_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Venue_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_venue_filter(inputs)
	return cs_calendar_venue_filter(inputs)
});